import classNames from 'classnames';
import React, { FC, memo } from 'react';
import useDevice from '@/hooks/useDevice';
import PageBody from './PageBody';
import './styles.css';

export interface PageContainerProps extends React.PropsWithChildren {
  title?: string;
  sideButton?: React.ReactNode;
  centerButton?: React.ReactNode;
  desktopLeftElement?: React.ReactNode;
  noPadding?: boolean;
  displayFlex?: boolean;
  hideScrollbar?: boolean;
  bodyClassName?: string;
  containerClassName?: string;
}

export const PageContainer: FC<PageContainerProps> = memo(({ containerClassName, bodyClassName, ...props }) => {
  const { isDesktop } = useDevice();

  return (
    <div
      className={classNames('w-full font-sans pt-1', containerClassName)}
      style={{ height: 'calc(100% - 50px)' }}
    >
      {props.title && (
        <div
          className={`page-container-title-bar flex items-center justify-between pb-2 ${!isDesktop() ? 'px-3' : ''}`}
        >
          <div
            className={
              isDesktop()
                ? '3xl:text-2xl text-xl font-bold mt-4 xl:mt-0'
                : 'font-l text-white'
            }>
            {props.title}
          </div>
          {isDesktop() && props.desktopLeftElement ? (
            props.desktopLeftElement
          ) : (
            <div />
          )}
          {props.centerButton || <div className="px-1" />}
          {props.sideButton || <div className="px-1" />}
        </div>
      )}
      <PageBody
        className={bodyClassName}
        noPadding={props.noPadding}
        displayFlex={props.displayFlex}
        hideScrollbar={props.hideScrollbar}>
        {props.children}
      </PageBody>
    </div>
  );
});

export default PageContainer;
